import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FaPrint, FaRecycle, FaUtensils, FaTruck, FaSearch, FaUser, FaUserPlus, FaChair, FaFileInvoice, FaEye, FaTrash, FaUndo, FaTimes, FaList, FaCalendarAlt } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Button, Badge, Modal } from 'react-bootstrap';
import { Box } from '@mui/system';
import PrintSaleInvoice from './PrintSaleInvoice';
import AddUserModel from './AddUserModel';
import OrderManagement from './OrderManagement';
import Puff from 'react-loading-icons/dist/esm/components/puff';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useStateContext } from '../Context/ContextProvider';
import { Clear } from '@mui/icons-material';

function FreshSaleEntry() {
  const [decideCustomer] = useState(localStorage.getItem('creditcash') || '1');
  const [products, setProducts] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  const { type, userId, weburl } = useStateContext();
  const { id } = useParams();
  const [salesman, setsalesman] = useState([]);
  const [results, setresults] = useState([]);
  const [item, setItem] = useState([]);
  const [selectedOptionsector, setSelectedOptionsector] = useState(0);
  const [selectedOptionshop, setSelectedOptionshop] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [subsectors, setSubsectors] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [grandTotal, setGrandTotal] = useState(0);
  const [pBlanace, setPbalance] = useState(0);
  const [shopId, setShopId] = useState(0);
  const [salesmanId, setSalesmanId] = useState(0);
  
  const inputRef = useRef(null);
  const inputRefCash = useRef(null);
  const autocompleteRef = useRef(null);

  const [entercash, setEntercash] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [ppadvance, setPPadvance] = useState(0);
  const [recovery, setRecovery] = useState(0);
  const [balance, setBalance] = useState(0);

  const [manualdate, setManualDate] = useState(getToday());
  const [salesTax, setSalesTax] = useState(0);
  const [salesTaxAmount, setSalesTaxAmount] = useState(0);
  const [serviceCharge, setServiceCharge] = useState(0);
  const [shipping, setShipping] = useState(0);
  const [printData, setPrintData] = useState([]);
  const [isPrint, setIsPrint] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isproducts, setIsProducts] = useState(true);
  const [isAddUser, setIsAddUser] = useState(false);
  const [isCheck] = useState(localStorage.getItem('radio') || '1');
  const [holdData, setHoldData] = useState(localStorage.getItem('customerData') ? JSON.parse(localStorage.getItem('customerData')) : []);
  const [category, setCategory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  
  // Restaurant POS states
  const [orderType, setOrderType] = useState('dining');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchCustomer, setSearchCustomer] = useState('');
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [isLoadingCustomers, setIsLoadingCustomers] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  // Mobile responsive states
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const [showMobileLeft, setShowMobileLeft] = useState(false);
  const [showMobileRight, setShowMobileRight] = useState(false);
  const [showMobileCenter, setShowMobileCenter] = useState(true);

  // Modals state
  const [showOrdersModal, setShowOrdersModal] = useState(false);
  const [showHoldModal, setShowHoldModal] = useState(false);
  const [selectedHoldOrder, setSelectedHoldOrder] = useState(null);
  const [showHoldDetails, setShowHoldDetails] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Handle window resize for mobile detection
  const prevIsMobileRef = useRef(null);

  useEffect(() => {
    const applyPanelDefaults = (mobile) => {
      if (!mobile) {
        setShowMobileLeft(true);
        setShowMobileRight(true);
        setShowMobileCenter(true);
      } else {
        setShowMobileLeft(false);
        setShowMobileRight(false);
        setShowMobileCenter(true);
      }
    };

    const initialMobile = window.innerWidth <= 992;
    setIsMobile(initialMobile);
    applyPanelDefaults(initialMobile);
    prevIsMobileRef.current = initialMobile;

    const handleResize = () => {
      const mobile = window.innerWidth <= 992;
      setIsMobile(mobile);
      if (mobile !== prevIsMobileRef.current) {
        applyPanelDefaults(mobile);
        prevIsMobileRef.current = mobile;
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    axios.get(`api/fetch/category`).then((res) => {
      setCategory(res.data.category);
    });
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      const val = e.target.value || 0;
      setSalesTax(parseFloat(val));
      toast.success('Updating delivery charges!', { position: "top-right", autoClose: 2000 });
    }
  };

  useEffect(() => {
    setIsProducts(false);
    axios.post(`api/productdetail/${id}?page=${currentPage}`)
      .then((res) => {
        setIsProducts(true);
        setProducts(res.data.data);
        setTotalPages(res.data.last_page);
      });
  }, [id, currentPage]);

  const handleFetchProductCategoryWise = (catid) => {
    setIsProducts(false);
    setShowCategoryModal(false);
    setSelectedCategory(category.find(c => c.id === catid));
    axios.get(`api/productdetail/categorywise/${catid}/${id}`)
      .then((res) => {
        setProducts(res.data.data);
        setTotalPages(res.data.last_page);
        setIsProducts(true);
      });
  };

  const setSalesTaxInLocalStorage = (e) => {
    setSalesTax(e.target.value || 0);
  };

  const HandleResetValues = () => {
    setItem([]);
    setSelectedCustomer(null);
    setDeliveryAddress('');
    setCustomerPhone('');
    setSearchCustomer('');
    setEntercash(0);
    setDiscount(0);
    setShipping(0);
    setServiceCharge(0);
    setSalesTax(0);
    setSalesTaxAmount(0);
    setSelectedCategory(null);
    filterCustomersByOrderType(orderType);
  };

  const handleHoldBack = (index) => {
    const holdItem = holdData[index];
    if (holdItem) {
      setItem(holdItem.items || []);
      setSelectedOptionsector(holdItem.name?.sector || 0);
      setSelectedOptionshop(holdItem.name?.subsector || 0);
      setShopId(holdItem.name?.ppcell || 0);
      
      if (holdItem.customer) {
        setSelectedCustomer(holdItem.customer);
        setCustomerPhone(holdItem.customer.phone || '');
      } else {
        setSelectedCustomer(null);
        setCustomerPhone('');
      }
      
      if (holdItem.orderType) {
        setOrderType(holdItem.orderType);
        setServiceCharge(0);
        setSalesTax(0);
        setSalesTaxAmount(0);
        filterCustomersByOrderType(holdItem.orderType);
      }
      
      const updatedHold = [...holdData];
      updatedHold.splice(index, 1);
      setHoldData(updatedHold);
      localStorage.setItem('customerData', JSON.stringify(updatedHold));
      
      const orderTypeDisplay = holdItem.orderType 
        ? holdItem.orderType.charAt(0).toUpperCase() + holdItem.orderType.slice(1) 
        : 'Dining';
      toast.success(`Order restored as ${orderTypeDisplay}!`, { 
        position: "top-right", 
        autoClose: 2000 
      });
      
      setShowHoldModal(false);
      setShowHoldDetails(false);
    }
  };

  const handleDeleteOnHold = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    const customerData = [...holdData];
    customerData.splice(index, 1);
    setHoldData(customerData);
    localStorage.setItem('customerData', JSON.stringify(customerData));
    toast.success('Hold order removed!', { position: "top-right", autoClose: 2000 });
    if (customerData.length === 0) {
      setShowHoldModal(false);
    }
  };

  const handleViewHoldDetails = (hold, index) => {
    setSelectedHoldOrder({ ...hold, index });
    setShowHoldDetails(true);
  };

  // Function to print hold invoice using the same PrintSaleInvoice component
  const handlePrintHoldInvoice = (hold, index) => {
    if (!hold || !hold.items || hold.items.length === 0) {
      toast.warning('No items in this hold order to print!', { 
        position: "top-right", 
        autoClose: 2000 
      });
      return;
    }

    // Calculate totals
    const total = hold.items.reduce((sum, item) => sum + (item.unitsaleprice * item.qty), 0);
    
    // Format the data to match what PrintSaleInvoice expects
    const printDataForHold = {
      letter: hold.items.map(item => ({
        ...item,
        subtotaldiscount: item.subtotaldiscount || 0,
        discountpercent: item.discountpercent || 0
      })),
      grandtotal: total.toFixed(2),
      remainingbill: total.toFixed(2),
      discount: 0,
      salestax: 0,
      shipping: 0,
      invoiceno: 'HOLD-' + Date.now(),
      dates: new Date().toLocaleDateString(),
      printingtime: new Date().toLocaleTimeString(),
      manualdate: new Date().toLocaleDateString(),
      customer: hold.customer || { name: 'Unknown Customer', phone: 'N/A' },
      customeraddress: hold.customer?.address || '',
      customerInfo: hold.customer || { name: 'Unknown Customer', phone: 'N/A' },
      salesman: { name: 'Hold Order', cnic: 'N/A' },
      payment: 0,
      recovery: 0,
      pbalance: 0,
      entercash: 0,
      mesg: '200',
      indicator: '1',
      detail: {
        logo: '/default-logo.png',
        slogan_heading: 'Restaurant POS',
        slogan_subheading: 'HOLD ORDER - TEMPORARY',
        gst: 'N/A',
        phone: 'N/A'
      },
      orderType: hold.orderType || 'dining',
      deliveryAddress: hold.deliveryAddress || ''
    };

    setPrintData(printDataForHold);
    setIsPrint(true);
    setShowHoldDetails(false);
    setShowHoldModal(false);
    
    toast.success('Printing hold invoice...', { 
      position: "top-right", 
      autoClose: 1500 
    });
  };

  function getToday() {
    const today = new Date();
    const year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, '0');
    let day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const handleDateChange = (e) => {
    setManualDate(e.target.value);
  };

  const handleAddNewUser = (childData) => {
    const data = {
      name: childData.name,
      phone: childData.phone,
      sector: selectedOptionsector,
      subsector: selectedOptionshop
    };
    axios.post('/api/add/customer/to/db', data).then(res => {
      if (res.data === 201) {
        toast.error('Phone Number Already Exist!', { position: "top-right", autoClose: 2000 });
      } else {
        toast.success('New Customer Added!', { position: "top-right", autoClose: 2000 });
        loadCustomers();
        filterCustomersByOrderType(orderType);
      }
    });
    setIsAddUser(false);
  };

  const filterCustomersByOrderType = useCallback((type) => {
    if (customerList.length === 0) return;
    
    let filtered;
    if (type === 'dining') {
      filtered = customerList.filter(customer => 
        customer.name.toLowerCase().startsWith('table')
      );
    } else if (type === 'delivery') {
      filtered = customerList.filter(customer => 
        !customer.name.toLowerCase().startsWith('table')
      );
    } else if (type === 'takeaway') {
      filtered = [...customerList];
    } else {
      filtered = [...customerList];
    }
    
    if (searchCustomer) {
      const search = searchCustomer.toLowerCase();
      filtered = filtered.filter(customer => 
        customer.name.toLowerCase().includes(search) || 
        (customer.phone && customer.phone.toLowerCase().includes(search))
      );
    }
    
    setFilteredCustomers(filtered);
  }, [customerList, searchCustomer]);

  const loadCustomers = useCallback(() => {
    if (selectedOptionshop && !isLoadingCustomers) {
      setIsLoadingCustomers(true);
      axios.get(`/api/getshop/${selectedOptionshop}`)
        .then(response => {
          const sortedShops = [...response.data.shop].sort((a, b) => a.name.localeCompare(b.name));
          setCustomerList(sortedShops);
          filterCustomersByOrderType(orderType);
          if (sortedShops.length > 0) {
            setShopId(sortedShops[0]['user_id']);
          }
          setIsLoadingCustomers(false);
          setIsFirstLoad(false);
        })
        .catch(error => {
          console.error(error);
          setIsLoadingCustomers(false);
          setIsFirstLoad(false);
        });
    }
  }, [selectedOptionshop, orderType, isLoadingCustomers, filterCustomersByOrderType]);

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (selectedOptionshop > 0 && isInitialMount.current) {
      loadCustomers();
      isInitialMount.current = false;
    }
  }, [selectedOptionshop, loadCustomers]);

  useEffect(() => {
    if (!isFirstLoad && customerList.length > 0) {
      filterCustomersByOrderType(orderType);
    }
  }, [orderType, customerList, isFirstLoad, filterCustomersByOrderType]);

  const handleModelClose = (data) => {
    setIsAddUser(data);
  };

  const shortcutremovinglastitem = useCallback((event) => {
    event.preventDefault();
    setItem(item.slice(0, item.length - 1));
  }, [item]);

  const handlePrintClick = () => {
    if (item.length === 0) {
      toast.warning('No items in cart!', { position: "top-right", autoClose: 2000 });
      return;
    }
    handleSaveReciept(new Event('click'));
  };

  const handleCustomerSelect = (customer) => {
    setSelectedCustomer(customer);
    setShopId(customer.user_id);
    setCustomerPhone(customer.phone || '');
    toast.success(`Customer selected: ${customer.name}`, { 
      position: "top-right", 
      autoClose: 1500 
    });
  };

  const handleSaveReciept = useCallback((e) => {
    e.preventDefault();
    
    if (!selectedCustomer) {
      toast.warning('Please select a customer from the customer column!', { 
        position: "top-right", 
        autoClose: 2000 
      });
      return;
    }
    
    setLoading(true);

    const deliveryChargeAmount = orderType === 'delivery' ? parseFloat(salesTax) : 0;
    const serviceChargeAmount = orderType === 'dining' ? parseFloat(serviceCharge) : 0;

    const data = {
      letter: item,
      sector: selectedOptionsector,
      subsector: selectedOptionshop,
      ppcell: shopId,
      manualdate: manualdate,
      recovery: recovery,
      ppadvance: ppadvance,
      salesmanid: type === 'Salesman' ? userId : salesmanId,
      sales_tex_percent: deliveryChargeAmount,
      service_charge: serviceChargeAmount,
      shipping: serviceChargeAmount,
      supergrandtotal: grandTotal,
      discount: discount,
      salesTaxAmount: deliveryChargeAmount,
      entercash: entercash,
      customer: selectedCustomer,
      orderType: orderType,
      deliveryAddress: deliveryAddress,
      customerPhone: customerPhone
    };

    if (data.letter.length > 0 && data.ppcell !== '' && data.manualdate) {
      axios.post('/api/post/reciept/entrysale', data)
        .then(res => {
          if (!res.data || !Array.isArray(res.data.cart)) {
            console.error('Unexpected response from entrysale API:', res.data);
            toast.error('Something went wrong saving the invoice. Please try again.', {
              position: "top-right",
              autoClose: 3000
            });
            setLoading(false);
            return;
          }

          const printDatas = {
            letter: res.data.cart,
            dates: res.data.dates,
            salestax: res.data.salestax,
            discount: res.data.discount,
            grandtotal: res.data.grandtotal,
            invoiceno: res.data.invoiceno,
            remainingbill: res.data.remainingbill,
            customer: res.data.customer,
            customeraddress: res.data.customeraddress,
            salesman: res.data.salesman,
            payment: res.data.payment,
            totalpay: res.data.totalpay,
            pbalance: res.data.pbalance,
            recovery: res.data.recovery,
            printingtime: res.data.printingtime,
            manualdate: res.data.manualdate,
            detail: res.data.detail,
            imagesrc: res.data.detail,
            shipping: res.data.shipping,
            entercash: entercash,
            mesg: res.data.mesg,
            indicator: '1',
            customerInfo: selectedCustomer,
            orderType: orderType,
            deliveryAddress: deliveryAddress
          };

          setPrintData(printDatas);
          setEntercash(0);
          setShipping(0);
          setServiceCharge(0);
          setSalesTax(0);
          setSalesTaxAmount(0);
          setIsPrint(true);
          setLoading(false);
        })
        .catch(err => {
          console.error('Failed to save invoice:', err);
          const serverMessage = err.response?.data?.message || err.response?.data?.error;
          toast.error(
            serverMessage || 'Failed to save invoice. Please check your connection and try again.',
            { position: "top-right", autoClose: 3000 }
          );
          setLoading(false);
        });
    } else {
      toast.warn('Fill all required fields!', { position: "top-right", autoClose: true });
      setLoading(false);
    }
  }, [discount, grandTotal, item, manualdate, ppadvance, recovery, salesTax, salesmanId, selectedOptionsector, selectedOptionshop, shopId, type, userId, entercash, selectedCustomer, orderType, deliveryAddress, customerPhone, serviceCharge]);

  useEffect(() => {
    if (isPrint) {
      const div = document.getElementById('printablearea');
      const win = window.open('', '', 'height=700,width=700');
      win.document.write(div.outerHTML);
      win.document.close();
      setTimeout(() => { win.print(); }, 2000);
      setIsPrint(false);
      setItem([]);
    }
  }, [isPrint]);

  useEffect(() => {
    const n = (val) => parseFloat(val) || 0;
    
    const deliveryChargeAmount = orderType === 'delivery' ? n(salesTax) : 0;
    const serviceChargeAmount = orderType === 'dining' ? n(serviceCharge) : 0;
    const totalCharges = deliveryChargeAmount + serviceChargeAmount;
    
    setSalesTaxAmount(totalCharges);
    
    if (decideCustomer === '1') {
      const afterdiscount = n(pBlanace) + n(grandTotal) - n(entercash) - n(discount);
      const assign = n(pBlanace) + n(grandTotal) - n(discount) + n(shipping) + totalCharges;
      setPPadvance(assign.toFixed(2));
      setRecovery(0);
      setBalance(afterdiscount.toFixed(2));
      setEntercash(assign.toFixed(2));
    } else {
      const totalWithCharges = n(grandTotal) - n(discount) + n(shipping) + totalCharges;
      if (parseFloat(entercash) > totalWithCharges) {
        const afterdiscount = n(pBlanace) + n(grandTotal) - n(entercash) - n(discount);
        setPPadvance(totalWithCharges.toFixed(2));
        setRecovery((parseFloat(entercash) - totalWithCharges).toFixed(2));
        setBalance(afterdiscount.toFixed(2));
      } else {
        const afterdiscount = n(pBlanace) + n(grandTotal) - n(entercash) - n(discount);
        setPPadvance(parseFloat(entercash));
        setRecovery(0);
        setBalance(afterdiscount.toFixed(2));
      }
    }
  }, [decideCustomer, entercash, pBlanace, discount, grandTotal, salesTax, shipping, orderType, serviceCharge]);

  const handleEntercash = (e) => {
    setEntercash(e.target.value === '' ? 0 : e.target.value);
  };

  const handleDiscount = (e) => {
    const val = e.target.value;
    if (val === '') {
      setDiscount(0);
    } else {
      const deliveryChargeAmount = orderType === 'delivery' ? parseFloat(salesTax) : 0;
      const serviceChargeAmount = orderType === 'dining' ? parseFloat(serviceCharge) : 0;
      const totalCharges = deliveryChargeAmount + serviceChargeAmount;
      if (parseFloat(val) > (parseFloat(grandTotal) + parseFloat(shipping) + totalCharges)) {
        toast.error('Discount is greater than total', { position: "top-right", autoClose: 2000 });
        setDiscount(0);
      } else {
        setDiscount(val);
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && autocompleteRef.current) {
      autocompleteRef.current.focus();
    }
  };

  useEffect(() => {
    const sumgrandtotal = item.reduce((acc, item) => acc + (parseFloat(item.unitsaleprice * item.qty) || 0), 0);
    setGrandTotal(sumgrandtotal.toFixed(2));
  }, [item]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [item.length]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.keyCode === 32) handleSaveReciept(event);
      if (event.ctrlKey && event.keyCode === 67) inputRefCash.current?.focus();
      if (event.ctrlKey && event.keyCode === 88) shortcutremovinglastitem(event);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [item, handleSaveReciept, shortcutremovinglastitem]);

  async function handleSubmit(val) {
    try {
      const newItem = results.find(item => item.id === val.id);
      if (!newItem) return;
      
      const itemExists = item.find(({ id }) => id === newItem.id);
      
      if (itemExists) {
        const updatedItems = item.map((existingItem) =>
          existingItem.id === newItem.id
            ? { ...existingItem, qty: existingItem.qty + 1 }
            : existingItem
        );
        setItem(updatedItems);
        setSelectedOption(null);
        toast.warning("Item Qty Added!", { position: "top-right", autoClose: 2000 });
      } else {
        const remqty = { remaining: newItem.qty, discountpercent: '0', subtotaldiscount: '0' };
        const unitPrice = isCheck === '1' ? newItem.unitsaleprice : 
                        isCheck === '2' ? newItem.unitretailprice : 
                        newItem.unitwholesaleprice;
        setItem([...item, { ...newItem, qty: 1, unitsaleprice: unitPrice, ...remqty }]);
        setSelectedOption(null);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    axios.get('/sanctum/csrf-cookie')
      .then(() => {
        Promise.all([
          axios.get(`/api/getsalesman`),
          axios.get(`/api/getsectors`),
        ])
          .then(responses => {
            const [salesmanRes, sectorsRes] = responses;
            setSalesmanId(salesmanRes.data.salesman[0]?.id || 0);
            setsalesman(salesmanRes.data.salesman);
            setSelectedOptionsector(sectorsRes.data.sectors[0]?.id || 0);
            if (sectorsRes.data.sectors.length > 0) {
              const firstSector = sectorsRes.data.sectors[0];
              axios.get(`/api/getsubsectors/${firstSector.id}`)
                .then(response => {
                  setSubsectors(response.data.subsectors);
                  setSelectedOptionshop(response.data.subsectors[0]?.id || 0);
                })
                .catch(error => console.error(error));
            }
          })
          .catch(error => console.error(error));
      })
      .catch(error => console.error(error));
  }, []);

  useEffect(() => {
    setLoading(true);
    axios.get(`/api/getproducts/${id}`).then(res => {
      setresults(res.data.skills);
      setLoading(false);
    });
  }, [id]);

  useEffect(() => {
    if (shopId > 0) {
      axios.post('/api/shopkeeper/pbalance', { id: shopId, salesman_id: salesmanId })
        .then(res => {
          setPbalance(res.data);
          setLoading(false);
        });
    } else {
      setPbalance(0);
    }
  }, [salesmanId, shopId]);

  const openAddCustomerFromModal = () => {
    setIsAddUser(true);
  };

  useEffect(() => {
    if (selectedOptionsector) {
      axios.get(`/api/getsubsectors/${selectedOptionsector}`)
        .then(response => {
          setSubsectors(response.data.subsectors);
          setSelectedOptionshop(response.data.subsectors[0]?.id || 0);
        })
        .catch(error => console.error(error));
    }
  }, [selectedOptionsector]);

  const handleRemove = (id) => {
    setItem(prevItems => prevItems.filter((item) => item.id !== id));
  };

  const handleCustomerSearch = (e) => {
    const search = e.target.value.toLowerCase();
    setSearchCustomer(search);
    filterCustomersByOrderType(orderType);
  };

  const isTableCustomer = (customer) => {
    return customer.name.toLowerCase().startsWith('table');
  };

  const isProductInCart = (productId) => item.some((i) => i.id === productId);

  const getProductCartQty = (productId) => {
    const found = item.find((i) => i.id === productId);
    return found ? found.qty : 0;
  };

  const handleOrderTypeChange = (type) => {
    setOrderType(type);
    setSelectedCustomer(null);
    setSearchCustomer('');
    setServiceCharge(0);
    setSalesTax(0);
    setSalesTaxAmount(0);
    
    if (customerList.length > 0) {
      filterCustomersByOrderType(type);
    }
  };

  const handleOrderComplete = (completedOrder) => {
    console.log('Order completed:', completedOrder);
  };

  const loadAllProducts = () => {
    setIsProducts(false);
    setShowCategoryModal(false);
    setSelectedCategory(null);
    axios.post(`api/productdetail/${id}?page=${currentPage}`)
      .then((res) => {
        setIsProducts(true);
        setProducts(res.data.data);
        setTotalPages(res.data.last_page);
      });
  };

  const handleHoldOrder = () => {
    if (item.length === 0) {
      toast.warning('No items to hold!', { position: "top-right", autoClose: 2000 });
      return;
    }
    
    const customer = {
      sector: selectedOptionsector,
      subsector: selectedOptionshop,
      ppcell: shopId,
    };
    const newCustomer = {
      name: customer,
      items: [...item],
      customer: selectedCustomer,
      orderType: orderType,
    };
    
    const existingData = localStorage.getItem('customerData') ? JSON.parse(localStorage.getItem('customerData')) : [];
    existingData.push(newCustomer);
    localStorage.setItem('customerData', JSON.stringify(existingData));
    setHoldData(JSON.parse(localStorage.getItem('customerData')));
    setItem([]);
    setSelectedCustomer(null);
    toast.success('Invoice on hold!', { position: "top-right", autoClose: 2000 });
    setShowHoldModal(true);
  };

  // Mobile toggle functions
  const toggleLeftPanel = () => {
    setShowMobileLeft(!showMobileLeft);
    if (showMobileLeft) {
      setShowMobileCenter(true);
    } else {
      setShowMobileCenter(false);
      setShowMobileRight(false);
    }
  };

  const toggleRightPanel = () => {
    setShowMobileRight(!showMobileRight);
    if (showMobileRight) {
      setShowMobileCenter(true);
    } else {
      setShowMobileCenter(false);
      setShowMobileLeft(false);
    }
  };

  const toggleCenterPanel = () => {
    if (showMobileLeft || showMobileRight) {
      setShowMobileLeft(false);
      setShowMobileRight(false);
      setShowMobileCenter(true);
    } else {
      setShowMobileCenter(!showMobileCenter);
      setShowMobileLeft(false);
      setShowMobileRight(false);
    }
  };

  return (
    <div className="restaurant-pos-wrapper">
      <style>{`
        /* ===== GLOBAL RESET & BASE ===== */
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        .restaurant-pos-wrapper {
          padding: 8px 12px;
          height: 100vh;
          overflow: hidden;
          background: #f8f9fa;
          position: relative;
        }

        /* ===== ANIMATIONS ===== */
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }
        @keyframes slideIn {
          from { opacity: 0; transform: translateX(-30px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(30px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .fade-in-down { animation: fadeInDown 0.4s ease; }
        .fade-in-up { animation: fadeInUp 0.4s ease; }
        .slide-in { animation: slideIn 0.3s ease; }
        .slide-in-right { animation: slideInRight 0.3s ease; }
        .slide-up { animation: slideUp 0.3s ease; }
        .pulse-hover:hover { animation: pulse 0.3s ease; }

        /* ===== TOP HEADER ===== */
        .pos-header {
          background: linear-gradient(135deg, #dc3545 0%, #c0392b 100%);
          padding: 8px 12px;
          border-radius: 10px;
          box-shadow: 0 3px 12px rgba(220, 53, 69, 0.4);
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
          margin-bottom: 8px;
          animation: fadeInDown 0.5s ease;
        }
        .pos-header .brand {
          display: flex;
          align-items: center;
          gap: 6px;
          color: white;
        }
        .pos-header .brand h4 {
          margin: 0;
          font-weight: 600;
          font-size: 16px;
          letter-spacing: 0.5px;
        }
        .pos-header .brand small {
          opacity: 0.8;
          font-size: 10px;
        }
        .pos-header .brand .date-picker-wrapper {
          display: flex;
          align-items: center;
          gap: 4px;
          background: rgba(255,255,255,0.15);
          padding: 2px 8px;
          border-radius: 20px;
          margin-left: 6px;
        }
        .pos-header .brand .date-picker-wrapper input[type="date"] {
          background: transparent;
          border: none;
          color: white;
          font-size: 11px;
          padding: 3px 4px;
          width: 110px;
          outline: none;
        }
        .pos-header .brand .date-picker-wrapper input[type="date"]::-webkit-calendar-picker-indicator {
          filter: invert(1);
          cursor: pointer;
        }
        .pos-header .brand .date-picker-wrapper .date-icon {
          font-size: 12px;
          color: rgba(255,255,255,0.8);
        }
        .order-type-buttons {
          display: flex;
          gap: 4px;
          flex-wrap: wrap;
        }
        .order-type-btn {
          padding: 4px 10px;
          border: 2px solid rgba(255,255,255,0.3);
          background: transparent;
          color: white;
          border-radius: 20px;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 11px;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 4px;
        }
        .order-type-btn:hover {
          background: rgba(255,255,255,0.1);
          border-color: rgba(255,255,255,0.6);
        }
        .order-type-btn.active {
          background: white;
          color: #dc3545;
          border-color: white;
          box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        }
        .pos-header .header-right {
          display: flex;
          align-items: center;
          gap: 6px;
          color: white;
          font-size: 11px;
          flex-wrap: wrap;
        }
        .pos-header .header-right .badge {
          font-size: 10px;
          padding: 3px 8px;
        }

        /* Mobile Navigation Buttons */
        .mobile-nav-buttons {
          display: none;
          gap: 4px;
          padding: 4px 0;
          flex-shrink: 0;
        }
        .mobile-nav-btn {
          padding: 4px 10px;
          border: 2px solid #dc3545;
          background: white;
          color: #dc3545;
          border-radius: 20px;
          font-size: 10px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 4px;
          flex: 1;
          justify-content: center;
        }
        .mobile-nav-btn.active {
          background: #dc3545;
          color: white;
        }
        .mobile-nav-btn:active {
          transform: scale(0.95);
        }

        /* ===== MAIN LAYOUT - THREE COLUMN LAYOUT ===== */
        .pos-main {
          display: flex;
          gap: 10px;
          height: calc(100vh - 72px);
          overflow: hidden;
        }

        /* ===== LEFT PANEL - CUSTOMERS ===== */
        .pos-left {
          width: 280px;
          min-width: 250px;
          max-width: 320px;
          background: white;
          border-radius: 10px;
          padding: 10px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
          display: flex;
          flex-direction: column;
          animation: fadeInDown 0.6s ease;
          overflow: hidden;
          border: 1px solid #f0f0f0;
          flex-shrink: 0;
        }

        .pos-left .customer-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 6px;
          flex-shrink: 0;
        }
        .pos-left .customer-header h6 {
          margin: 0;
          font-weight: 600;
          color: #2d3436;
          font-size: 12px;
          display: flex;
          align-items: center;
          gap: 4px;
        }
        .pos-left .customer-search-box {
          position: relative;
          margin-bottom: 6px;
          flex-shrink: 0;
        }
        .pos-left .customer-search-box input {
          width: 100%;
          padding: 4px 8px 4px 26px;
          border: 2px solid #e0e0e0;
          border-radius: 16px;
          font-size: 11px;
          transition: all 0.3s ease;
          background: #f8f9fa;
        }
        .pos-left .customer-search-box input:focus {
          border-color: #dc3545;
          outline: none;
          box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
          background: white;
        }
        .pos-left .customer-search-box .search-icon {
          position: absolute;
          left: 8px;
          top: 50%;
          transform: translateY(-50%);
          color: #999;
          font-size: 10px;
        }

        .pos-left .customer-list {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          padding-right: 2px;
        }
        .pos-left .customer-list::-webkit-scrollbar {
          width: 3px;
        }
        .pos-left .customer-list::-webkit-scrollbar-thumb {
          background: #dc3545;
          border-radius: 10px;
        }

        .pos-left .customer-item {
          padding: 5px 6px;
          margin-bottom: 2px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          border: 2px solid transparent;
          display: flex;
          align-items: center;
          gap: 5px;
          background: #f8f9fa;
        }
        .pos-left .customer-item:hover {
          background: #fff5f5;
          border-color: #fcc;
        }
        .pos-left .customer-item.selected {
          background: #dc3545;
          color: white;
          border-color: #dc3545;
          box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
        }
        .pos-left .customer-item .customer-avatar {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #e9ecef;
          flex-shrink: 0;
          font-size: 10px;
        }
        .pos-left .customer-item.selected .customer-avatar {
          background: rgba(255,255,255,0.2);
        }
        .pos-left .customer-item .customer-info {
          flex: 1;
          min-width: 0;
        }
        .pos-left .customer-item .customer-name {
          font-size: 10px;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .pos-left .customer-item.selected .customer-name {
          color: white;
        }
        .pos-left .customer-item .customer-phone {
          font-size: 8px;
          color: #888;
        }
        .pos-left .customer-item.selected .customer-phone {
          color: rgba(255,255,255,0.8);
        }
        .pos-left .customer-item .customer-badge {
          font-size: 7px;
          padding: 1px 5px;
          border-radius: 6px;
          background: #d4edda;
          color: #155724;
          flex-shrink: 0;
        }
        .pos-left .customer-item.selected .customer-badge {
          background: rgba(255,255,255,0.2);
          color: white;
        }

        .pos-left .add-customer-btn-small {
          width: 100%;
          padding: 4px;
          margin-top: 4px;
          border: 2px dashed #dc3545;
          border-radius: 16px;
          background: transparent;
          color: #dc3545;
          font-weight: 500;
          font-size: 10px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          flex-shrink: 0;
        }
        .pos-left .add-customer-btn-small:hover {
          background: #dc3545;
          color: white;
          border-color: #dc3545;
        }

        .pos-left .empty-customers {
          text-align: center;
          padding: 15px 8px;
          color: #bbb;
        }
        .pos-left .empty-customers .empty-icon {
          font-size: 28px;
          display: block;
          margin-bottom: 4px;
          opacity: 0.5;
        }
        .pos-left .empty-customers p {
          font-size: 11px;
          margin: 0;
        }

        /* ===== CENTER PANEL - BILL/CART ===== */
        .pos-center {
          flex: 1;
          min-width: 0;
          background: white;
          border-radius: 10px;
          padding: 8px 10px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
          display: flex;
          flex-direction: column;
          animation: fadeInDown 0.7s ease;
          overflow: hidden;
          border: 1px solid #f0f0f0;
        }

        /* Product Search in Center - Compact */
        .pos-center .product-search {
          flex-shrink: 0;
          margin-bottom: 4px;
        }
        .pos-center .product-search .MuiAutocomplete-root {
          width: 100%;
        }
        .pos-center .product-search .MuiOutlinedInput-root {
          border-radius: 18px;
          background: #f8f9fa;
          height: 34px;
        }
        .pos-center .product-search .MuiOutlinedInput-root input {
          padding: 4px 10px;
          font-size: 12px;
        }
        .pos-center .product-search .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
          border-width: 1px;
        }
        .pos-center .product-search .MuiOutlinedInput-root.Mui-focused {
          box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.2);
        }
        .pos-center .product-search .MuiInputLabel-root {
          font-size: 11px;
          top: -3px;
        }
        .pos-center .product-search .MuiInputLabel-shrink {
          font-size: 10px;
          top: 2px;
        }

        /* Cart Header in Center - Compact */
        .pos-center .cart-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 3px;
          flex-shrink: 0;
        }
        .pos-center .cart-header h6 {
          margin: 0;
          font-weight: 600;
          color: #2d3436;
          font-size: 12px;
        }
        .pos-center .cart-header .header-actions {
          display: flex;
          gap: 3px;
        }
        .pos-center .cart-header .header-actions .hold-view-btn {
          padding: 2px 8px;
          font-size: 10px;
          border-radius: 14px;
          border: none;
          background: #f39c12;
          color: white;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 3px;
          font-weight: 500;
        }
        .pos-center .cart-header .header-actions .hold-view-btn:hover {
          background: #e67e22;
          transform: scale(1.05);
        }
        .pos-center .cart-header .header-actions .hold-view-btn .badge-hold {
          background: #dc3545;
          color: white;
          border-radius: 50%;
          padding: 0 4px;
          font-size: 8px;
          margin-left: 2px;
        }
        .pos-center .cart-header .header-actions button.btn {
          padding: 2px 6px;
          font-size: 10px;
        }

        /* Selected Customer Info - Compact */
        .pos-center .selected-customer-info {
          padding: 2px 6px;
          background: #fff5f5;
          border-radius: 4px;
          margin-bottom: 3px;
          display: flex;
          align-items: center;
          gap: 4px;
          flex-shrink: 0;
          border: 1px solid #fcc;
          overflow: hidden;
          height: 24px;
        }
        .pos-center .selected-customer-info .cust-icon {
          font-size: 10px;
          color: #dc3545;
        }
        .pos-center .selected-customer-info .cust-name {
          font-size: 10px;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .pos-center .selected-customer-info .cust-phone {
          font-size: 9px;
          color: #888;
          white-space: nowrap;
        }
        .pos-center .selected-customer-info .cust-type {
          font-size: 9px;
          color: #888;
          margin-left: auto;
          white-space: nowrap;
        }

        /* Cart Items */
        .pos-center .cart-items {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          padding-right: 2px;
          min-height: 120px;
        }
        .pos-center .cart-items::-webkit-scrollbar {
          width: 3px;
        }
        .pos-center .cart-items::-webkit-scrollbar-thumb {
          background: #dc3545;
          border-radius: 10px;
        }

        .pos-center .cart-item {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 4px 6px;
          margin-bottom: 2px;
          background: #f8f9fa;
          border-radius: 4px;
          transition: all 0.3s ease;
          border-left: 3px solid #dc3545;
        }
        .pos-center .cart-item:hover {
          background: #fff5f5;
        }
        .pos-center .cart-item .item-details {
          flex: 1;
          min-width: 0;
        }
        .pos-center .cart-item .item-name {
          font-size: 11px;
          font-weight: 500;
          color: #2d3436;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .pos-center .cart-item .item-controls {
          display: flex;
          align-items: center;
          gap: 2px;
          margin-top: 1px;
          flex-wrap: wrap;
        }
        .pos-center .cart-item .item-controls input[type="number"] {
          width: 32px;
          padding: 1px 2px;
          border: 1px solid #ddd;
          border-radius: 3px;
          font-size: 10px;
          text-align: center;
          height: 20px;
        }
        .pos-center .cart-item .item-controls input[type="number"]:focus {
          border-color: #dc3545;
          outline: none;
        }
        .pos-center .cart-item .item-total {
          font-size: 11px;
          font-weight: 600;
          color: #dc3545;
          min-width: 40px;
          text-align: right;
          flex-shrink: 0;
        }
        .pos-center .cart-item .remove-btn {
          color: #dc3545;
          background: none;
          border: none;
          cursor: pointer;
          padding: 1px;
          border-radius: 50%;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          flex-shrink: 0;
        }
        .pos-center .cart-item .remove-btn:hover {
          background: #fee;
          transform: scale(1.2);
        }

        .pos-center .empty-cart {
          text-align: center;
          padding: 20px 8px;
          color: #bbb;
        }
        .pos-center .empty-cart .empty-icon {
          font-size: 28px;
          display: block;
          margin-bottom: 4px;
          opacity: 0.5;
        }
        .pos-center .empty-cart p {
          font-size: 12px;
          margin: 0;
        }
        .pos-center .empty-cart small {
          font-size: 10px;
        }

        /* Cart Totals - Compact */
        .pos-center .cart-totals {
          flex-shrink: 0;
          border-top: 2px solid #f0f0f0;
          padding-top: 3px;
          margin-top: 2px;
        }
        .pos-center .total-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1px 0;
          font-size: 11px;
        }
        .pos-center .total-row input {
          width: 55px;
          padding: 1px 3px;
          border: 1px solid #ddd;
          border-radius: 3px;
          font-size: 10px;
          text-align: center;
          height: 20px;
        }
        .pos-center .total-row input:focus {
          border-color: #dc3545;
          outline: none;
        }
        .pos-center .total-row .total-label {
          color: #555;
        }
        .pos-center .total-row .total-value {
          font-weight: 600;
          color: #2d3436;
        }
        .pos-center .grand-total-row {
          padding: 3px 0;
          border-top: 2px solid #dc3545;
          margin-top: 2px;
        }
        .pos-center .grand-total-row .total-label {
          font-size: 13px;
          font-weight: 700;
          color: #2d3436;
        }
        .pos-center .grand-total-row .total-value {
          font-size: 15px;
          font-weight: 700;
          color: #dc3545;
        }

        /* Payment Section - Compact */
        .pos-center .payment-section {
          flex-shrink: 0;
          border-top: 1px solid #f0f0f0;
          padding-top: 3px;
          margin-top: 2px;
        }
        .pos-center .payment-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1px 0;
          font-size: 11px;
        }
        .pos-center .payment-row input {
          width: 70px;
          padding: 1px 4px;
          border: 1px solid #ddd;
          border-radius: 3px;
          font-size: 10px;
          text-align: center;
          height: 22px;
        }
        .pos-center .payment-row input:focus {
          border-color: #dc3545;
          outline: none;
        }
        .pos-center .balance-amount {
          font-size: 12px;
          font-weight: 700;
          color: #28a745;
        }
        .pos-center .balance-amount.negative {
          color: #dc3545;
        }

        /* Print Button - Compact */
        .pos-center .print-btn {
          width: 100%;
          padding: 5px;
          margin-top: 3px;
          border: none;
          border-radius: 18px;
          background: linear-gradient(135deg, #dc3545 0%, #c0392b 100%);
          color: white;
          font-weight: 600;
          font-size: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          flex-shrink: 0;
          height: 30px;
        }
        .pos-center .print-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 20px rgba(220, 53, 69, 0.4);
        }
        .pos-center .print-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .pos-center .print-btn-secondary {
          width: 100%;
          padding: 5px;
          margin-top: 3px;
          border: none;
          border-radius: 18px;
          background: linear-gradient(135deg, #f39c12 0%, #e67e22 100%);
          color: white;
          font-weight: 600;
          font-size: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          flex-shrink: 0;
          height: 30px;
        }
        .pos-center .print-btn-secondary:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 20px rgba(243, 156, 18, 0.4);
        }

        .pos-center .action-buttons {
          display: flex;
          gap: 4px;
          flex-shrink: 0;
        }
        .pos-center .action-buttons .print-btn {
          flex: 1;
        }
        .pos-center .action-buttons .print-btn-secondary {
          flex: 0.5;
        }

        /* ===== RIGHT PANEL - PRODUCTS ===== */
        .pos-right {
          width: 340px;
          min-width: 300px;
          max-width: 380px;
          background: white;
          border-radius: 10px;
          padding: 8px 10px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
          display: flex;
          flex-direction: column;
          animation: fadeInDown 0.8s ease;
          overflow: hidden;
          border: 1px solid #f0f0f0;
          flex-shrink: 0;
        }

        /* Mobile panel header with close button (Products panel) */
        .pos-right .mobile-panel-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          padding-bottom: 8px;
          border-bottom: 2px solid #f0f0f0;
          flex-shrink: 0;
        }
        .pos-right .mobile-panel-header h6 {
          margin: 0;
          font-weight: 600;
          color: #2d3436;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .pos-right .mobile-panel-close-btn {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          border: none;
          background: #f8f9fa;
          color: #dc3545;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s ease;
          flex-shrink: 0;
        }
        .pos-right .mobile-panel-close-btn:hover {
          background: #dc3545;
          color: white;
          transform: rotate(90deg);
        }
        .pos-right .mobile-panel-close-btn:active {
          transform: scale(0.9);
        }

        /* Category Trigger - Compact */
        .pos-right .category-trigger {
          background: #f8f9fa;
          border-radius: 6px;
          padding: 4px 8px;
          box-shadow: 0 1px 4px rgba(0,0,0,0.06);
          border: 1px solid #f0f0f0;
          display: flex;
          align-items: center;
          gap: 4px;
          cursor: pointer;
          transition: all 0.3s ease;
          flex-shrink: 0;
          margin-bottom: 4px;
          justify-content: space-between;
        }
        .pos-right .category-trigger:hover {
          border-color: #dc3545;
          box-shadow: 0 2px 12px rgba(220, 53, 69, 0.1);
        }
        .pos-right .category-trigger .cat-label {
          font-weight: 500;
          color: #2d3436;
          font-size: 11px;
        }
        .pos-right .category-trigger .cat-selected {
          color: #dc3545;
          font-weight: 600;
          font-size: 11px;
        }
        .pos-right .category-trigger .cat-arrow {
          color: #999;
          transition: transform 0.3s ease;
        }
        .pos-right .category-trigger:hover .cat-arrow {
          transform: translateX(4px);
          color: #dc3545;
        }

        /* Product Grid */
        .pos-right .product-grid {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 6px;
          padding: 2px 0;
        }
        .pos-right .product-grid::-webkit-scrollbar {
          width: 3px;
        }
        .pos-right .product-grid::-webkit-scrollbar-thumb {
          background: #dc3545;
          border-radius: 10px;
        }

        .pos-right .product-card {
          background: white;
          border-radius: 4px;
          padding: 4px;
          text-align: center;
          cursor: pointer;
          transition: all 0.3s ease;
          border: 2px solid #f0f0f0;
          box-shadow: 0 1px 3px rgba(0,0,0,0.04);
        }
        .pos-right .product-card:hover {
          transform: translateY(-2px) scale(1.02);
          box-shadow: 0 4px 12px rgba(220, 53, 69, 0.2);
          border-color: #dc3545;
        }
        .pos-right .product-card:active {
          transform: scale(0.95);
        }
        .pos-right .product-card.in-cart {
          border-color: #28a745;
          background: #f0fff4;
          box-shadow: 0 2px 8px rgba(40, 167, 69, 0.25);
        }
        .pos-right .product-card.in-cart:hover {
          border-color: #28a745;
          box-shadow: 0 4px 14px rgba(40, 167, 69, 0.35);
        }
        .pos-right .product-card.in-cart .product-name {
          color: #1e7e34;
        }
        .pos-right .product-card .cart-qty-badge {
          display: inline-block;
          margin-top: 2px;
          padding: 1px 5px;
          font-size: 7px;
          font-weight: 700;
          color: white;
          background: #28a745;
          border-radius: 8px;
          white-space: nowrap;
        }
        .pos-right .product-card .product-image {
          width: 100%;
          height: 50px;
          object-fit: cover;
          border-radius: 3px;
          background: #f8f9fa;
        }
        .pos-right .product-card .product-name {
          font-size: 9px;
          font-weight: 600;
          margin: 2px 0 1px;
          color: #2d3436;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .pos-right .product-card .product-price {
          font-size: 11px;
          font-weight: 700;
          color: #dc3545;
          margin: 0;
        }
        .pos-right .product-card .product-unit {
          font-size: 7px;
          color: #999;
        }
        .pos-right .product-card .quick-add-btn {
          margin-top: 2px;
          padding: 1px 6px;
          font-size: 8px;
          border-radius: 8px;
          border: none;
          background: #dc3545;
          color: white;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .pos-right .product-card .quick-add-btn:hover {
          background: #c0392b;
          transform: scale(1.05);
        }
        .pos-right .product-card.in-cart .quick-add-btn {
          background: #28a745;
        }
        .pos-right .product-card.in-cart .quick-add-btn:hover {
          background: #1e7e34;
        }

        .pos-right .loading-products {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          grid-column: 1 / -1;
          padding: 15px 0;
          color: #999;
        }

        /* Pagination - Compact */
        .pos-right .pagination-controls {
          flex-shrink: 0;
          display: flex;
          justify-content: center;
          gap: 4px;
          padding-top: 4px;
        }
        .pos-right .pagination-controls .page-btn {
          padding: 2px 8px;
          border: 1px solid #ddd;
          border-radius: 10px;
          background: white;
          font-size: 10px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .pos-right .pagination-controls .page-btn:hover:not(:disabled) {
          background: #dc3545;
          color: white;
          border-color: #dc3545;
        }
        .pos-right .pagination-controls .page-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }
        .pos-right .pagination-controls .page-info {
          font-size: 10px;
          padding: 2px 8px;
          background: #f0f0f0;
          border-radius: 10px;
          color: #555;
        }

        /* ===== MODAL STYLES ===== */
        .category-modal .modal-content {
          border-radius: 16px;
          border: none;
          box-shadow: 0 10px 40px rgba(0,0,0,0.2);
        }
        .category-modal .modal-header {
          background: linear-gradient(135deg, #dc3545 0%, #c0392b 100%);
          color: white;
          border-radius: 16px 16px 0 0;
          padding: 12px 16px;
        }
        .category-modal .modal-header .modal-title {
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 16px;
        }
        .category-modal .modal-header .btn-close {
          filter: brightness(0) invert(1);
          opacity: 0.8;
        }
        .category-modal .modal-body {
          padding: 16px;
          max-height: calc(90vh - 140px);
          overflow-y: auto;
        }
        .category-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
          gap: 10px;
        }
        .category-grid .cat-item {
          background: #f8f9fa;
          border-radius: 10px;
          padding: 12px;
          text-align: center;
          cursor: pointer;
          transition: all 0.3s ease;
          border: 2px solid transparent;
        }
        .category-grid .cat-item:hover {
          transform: translateY(-4px);
          box-shadow: 0 4px 15px rgba(0,0,0,0.1);
          border-color: #dc3545;
          background: white;
        }
        .category-grid .cat-item .cat-icon-lg {
          font-size: 28px;
          margin-bottom: 6px;
        }
        .category-grid .cat-item .cat-name-lg {
          font-weight: 600;
          color: #2d3436;
          font-size: 13px;
        }
        .category-grid .cat-item .cat-count-lg {
          font-size: 11px;
          color: #999;
        }

        /* ===== HOLD ORDERS MODAL ===== */
        .hold-modal .modal-content,
        .hold-detail-modal .modal-content {
          border-radius: 16px;
          border: none;
          box-shadow: 0 10px 40px rgba(0,0,0,0.2);
        }
        .hold-modal .modal-header,
        .hold-detail-modal .modal-header {
          background: linear-gradient(135deg, #f39c12 0%, #e67e22 100%);
          color: white;
          border-radius: 16px 16px 0 0;
          padding: 12px 16px;
        }
        .hold-modal .modal-header .modal-title,
        .hold-detail-modal .modal-header .modal-title {
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 16px;
        }
        .hold-modal .modal-header .btn-close,
        .hold-detail-modal .modal-header .btn-close {
          filter: brightness(0) invert(1);
          opacity: 0.8;
        }
        .hold-modal .modal-body {
          padding: 0;
          max-height: calc(90vh - 130px);
          overflow-y: auto;
          background: white;
        }

        /* ----- Table layout ----- */
        .hold-table-wrapper {
          width: 100%;
          overflow-x: auto;
        }
        .hold-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
        }
        .hold-table thead th {
          position: sticky;
          top: 0;
          z-index: 1;
          background: #f8f9fa;
          color: #555;
          text-align: left;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.4px;
          padding: 10px 14px;
          border-bottom: 2px solid #eee;
          white-space: nowrap;
        }
        .hold-table thead th.col-total,
        .hold-table thead th.col-actions {
          text-align: center;
        }

        .hold-table tbody tr.hold-row {
          border-bottom: 1px solid #f0f0f0;
          transition: background 0.2s ease;
        }
        .hold-table tbody tr.hold-row:hover {
          background: #fffaf3;
        }
        .hold-table tbody tr.hold-row:last-child {
          border-bottom: none;
        }
        .hold-table td {
          padding: 10px 14px;
          vertical-align: middle;
        }

        .hold-table td.col-customer {
          font-weight: 600;
          color: #2d3436;
          min-width: 140px;
        }
        .hold-customer-cell {
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .hold-customer-cell .row-icon {
          color: #f39c12;
          font-size: 12px;
          flex-shrink: 0;
        }

        .hold-table td.col-type {
          white-space: nowrap;
        }
        .order-type-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 3px 10px;
          border-radius: 12px;
          font-size: 10px;
          font-weight: 600;
          text-transform: capitalize;
          white-space: nowrap;
        }
        .order-type-badge.dining {
          background: #d4edda;
          color: #155724;
        }
        .order-type-badge.delivery {
          background: #cce5ff;
          color: #004085;
        }
        .order-type-badge.takeaway {
          background: #fff3cd;
          color: #856404;
        }

        .hold-table td.col-items {
          min-width: 220px;
        }
        .hold-items-preview {
          display: flex;
          flex-wrap: wrap;
          gap: 4px;
        }
        .hold-items-preview .item-tag {
          background: #f8f9fa;
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 2px 8px;
          font-size: 10px;
          color: #555;
          white-space: nowrap;
        }
        .hold-items-preview .item-tag span {
          font-weight: 700;
          color: #dc3545;
        }
        .hold-items-preview .item-tag.more-tag {
          background: #fff3cd;
          color: #856404;
          border-color: #ffe8a1;
          font-weight: 600;
        }

        .hold-table td.col-total {
          text-align: center;
          white-space: nowrap;
        }
        .hold-total-value {
          font-size: 14px;
          font-weight: 700;
          color: #dc3545;
        }

        .hold-table td.col-actions {
          white-space: nowrap;
        }
        .hold-actions {
          display: flex;
          gap: 6px;
          justify-content: center;
        }
        .hold-actions button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          border: none;
          border-radius: 50%;
          font-size: 12px;
          cursor: pointer;
          transition: all 0.2s ease;
          color: white;
          flex-shrink: 0;
        }
        .hold-actions .view-btn {
          background: #3498db;
        }
        .hold-actions .view-btn:hover {
          background: #2980b9;
          transform: scale(1.1);
        }
        .hold-actions .print-btn-hold {
          background: #17a2b8;
        }
        .hold-actions .print-btn-hold:hover {
          background: #138496;
          transform: scale(1.1);
        }
        .hold-actions .restore-btn {
          background: #28a745;
        }
        .hold-actions .restore-btn:hover {
          background: #218838;
          transform: scale(1.1);
        }
        .hold-actions .delete-btn {
          background: #dc3545;
        }
        .hold-actions .delete-btn:hover {
          background: #c82333;
          transform: scale(1.1);
        }

        .empty-holds-modal {
          text-align: center;
          padding: 40px 16px;
          color: #bbb;
        }
        .empty-holds-modal .empty-icon {
          font-size: 40px;
          display: block;
          margin-bottom: 10px;
          opacity: 0.6;
        }
        .empty-holds-modal h5 {
          color: #777;
          font-size: 15px;
          margin-bottom: 4px;
        }
        .empty-holds-modal p {
          font-size: 12px;
        }

        /* Table responsive tweaks for mobile */
        @media (max-width: 768px) {
          .hold-table {
            font-size: 12px;
          }
          .hold-table thead th,
          .hold-table td {
            padding: 8px 10px;
          }
          .hold-table td.col-items {
            min-width: 160px;
          }
          .hold-actions button {
            width: 26px;
            height: 26px;
          }
        }

        /* ===== HOLD ORDER DETAILS MODAL ===== */
        .hold-detail-modal .modal-body {
          padding: 16px;
        }
        .hold-detail-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 6px 0;
          border-bottom: 1px solid #f5f5f5;
          font-size: 13px;
        }
        .hold-detail-item:last-child {
          border-bottom: none;
        }
        .hold-detail-item .item-name {
          color: #2d3436;
        }
        .hold-detail-item .item-price {
          font-weight: 600;
          color: #dc3545;
        }
        .hold-detail-total {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          padding-top: 10px;
          border-top: 2px solid #f0f0f0;
          font-size: 14px;
          font-weight: 600;
          color: #2d3436;
        }
        .hold-detail-total span {
          font-size: 17px;
          font-weight: 700;
          color: #dc3545;
        }

        /* ===== RESPONSIVE DESIGN ===== */
        
        /* Tablet and smaller */
        @media (max-width: 1200px) {
          .pos-left { width: 250px; min-width: 220px; }
          .pos-right { width: 300px; min-width: 260px; }
          .pos-right .product-grid { grid-template-columns: repeat(2, 1fr); }
        }

        /* Mobile - Tablet/Phone */
        @media (max-width: 992px) {
          .restaurant-pos-wrapper {
            padding: 4px 6px;
            height: 100vh;
            overflow: hidden;
          }
          
          .pos-header {
            padding: 6px 10px;
            border-radius: 8px;
            gap: 4px;
            margin-bottom: 4px;
            flex-wrap: wrap;
          }
          .pos-header .brand h4 {
            font-size: 14px;
          }
          .pos-header .brand small {
            display: none;
          }
          .pos-header .brand .date-picker-wrapper input[type="date"] {
            width: 90px;
            font-size: 10px;
          }
          .order-type-btn {
            font-size: 9px;
            padding: 3px 8px;
          }
          .pos-header .header-right .badge {
            font-size: 8px;
            padding: 2px 6px;
          }

          .mobile-nav-buttons {
            display: flex;
          }

          .pos-main {
            flex-direction: row;
            height: calc(100vh - 80px);
            gap: 0;
            position: relative;
            overflow: hidden;
          }

          /* Mobile panels - slide in/out */
          .pos-left {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 280px;
            max-width: 85%;
            min-width: unset;
            z-index: 100;
            border-radius: 10px;
            box-shadow: 0 4px 30px rgba(0,0,0,0.3);
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            transform: translateX(-110%);
            padding: 10px;
            max-height: 90vh;
            overflow-y: auto;
          }
          .pos-left.mobile-open {
            transform: translateX(0);
          }

          .pos-center {
            width: 100%;
            border-radius: 10px;
            padding: 6px 8px;
            margin: 0;
            height: 100%;
          }
          .pos-center.mobile-hidden {
            display: none;
          }

          .pos-right {
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            width: 100%;
            max-width: 100%;
            min-width: unset;
            z-index: 100;
            border-radius: 10px;
            box-shadow: 0 4px 30px rgba(0,0,0,0.3);
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            transform: translateX(110%);
            padding: 8px 10px;
            max-height: 100vh;
            overflow-y: auto;
          }
          .pos-right.mobile-open {
            transform: translateX(0);
          }

          /* Mobile overlay */
          .mobile-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.5);
            z-index: 99;
            animation: fadeIn 0.3s ease;
          }
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }

          /* Center panel adjustments for mobile */
          .pos-center .product-search .MuiOutlinedInput-root {
            height: 30px;
          }
          .pos-center .product-search .MuiOutlinedInput-root input {
            font-size: 11px;
            padding: 3px 8px;
          }
          .pos-center .cart-items {
            min-height: 80px;
          }
          .pos-center .cart-item {
            padding: 3px 4px;
          }
          .pos-center .cart-item .item-name {
            font-size: 10px;
          }
          .pos-center .cart-item .item-controls input[type="number"] {
            width: 28px;
            font-size: 9px;
            height: 18px;
          }
          .pos-center .cart-item .item-total {
            font-size: 10px;
            min-width: 35px;
          }
          .pos-center .cart-item .item-controls input[type="number"]:last-of-type {
            width: 50px;
          }
          .pos-center .total-row {
            font-size: 10px;
          }
          .pos-center .total-row input {
            width: 45px;
            height: 18px;
            font-size: 9px;
          }
          .pos-center .grand-total-row .total-label {
            font-size: 12px;
          }
          .pos-center .grand-total-row .total-value {
            font-size: 13px;
          }
          .pos-center .payment-row {
            font-size: 10px;
          }
          .pos-center .payment-row input {
            width: 60px;
            height: 20px;
            font-size: 9px;
          }
          .pos-center .print-btn {
            height: 28px;
            font-size: 11px;
            padding: 4px;
          }
          .pos-center .print-btn-secondary {
            height: 28px;
            font-size: 11px;
            padding: 4px;
          }

          .pos-right .product-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 4px;
          }
          .pos-right .product-card .product-image {
            height: 40px;
          }
          .pos-right .product-card .product-name {
            font-size: 8px;
          }
          .pos-right .product-card .product-price {
            font-size: 9px;
          }
          .pos-right .category-trigger {
            padding: 3px 6px;
          }
          .pos-right .category-trigger .cat-label {
            font-size: 10px;
          }
          .pos-right .category-trigger .cat-selected {
            font-size: 10px;
          }
        }

        /* Small phones */
        @media (max-width: 576px) {
          .restaurant-pos-wrapper {
            padding: 3px 4px;
          }
          
          .pos-header {
            padding: 4px 8px;
            border-radius: 6px;
          }
          .pos-header .brand h4 {
            font-size: 12px;
          }
          .pos-header .brand .date-picker-wrapper {
            padding: 1px 4px;
          }
          .pos-header .brand .date-picker-wrapper input[type="date"] {
            width: 70px;
            font-size: 9px;
            padding: 1px 2px;
          }
          .pos-header .brand .date-picker-wrapper .date-icon {
            font-size: 10px;
          }
          .order-type-btn {
            font-size: 8px;
            padding: 2px 6px;
          }
          .pos-header .header-right .badge {
            font-size: 7px;
            padding: 1px 4px;
          }

          .pos-left {
            width: 260px;
            padding: 8px;
          }
          .pos-right {
            width: 100%;
            max-width: 100%;
            padding: 6px 8px;
          }

          .pos-center .cart-header h6 {
            font-size: 10px;
          }
          .pos-center .cart-header .header-actions .hold-view-btn {
            font-size: 8px;
            padding: 1px 6px;
          }
          .pos-center .selected-customer-info {
            height: 20px;
            padding: 1px 4px;
          }
          .pos-center .selected-customer-info .cust-name {
            font-size: 9px;
          }
          .pos-center .selected-customer-info .cust-phone {
            font-size: 8px;
          }
          .pos-center .selected-customer-info .cust-type {
            font-size: 8px;
          }
          .pos-center .cart-item .item-name {
            font-size: 9px;
          }
          .pos-center .cart-item .item-controls input[type="number"] {
            width: 24px;
            font-size: 8px;
            height: 16px;
          }
          .pos-center .cart-item .item-controls input[type="number"]:last-of-type {
            width: 40px;
          }
          .pos-center .cart-item .item-total {
            font-size: 9px;
            min-width: 30px;
          }
          .pos-center .empty-cart .empty-icon {
            font-size: 24px;
          }
          .pos-center .empty-cart p {
            font-size: 10px;
          }

          .pos-right .product-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          .pos-right .product-card .product-image {
            height: 35px;
          }
          .pos-right .product-card .product-name {
            font-size: 7px;
          }
          .pos-right .product-card .product-price {
            font-size: 8px;
          }
          .pos-right .product-card .quick-add-btn {
            font-size: 7px;
            padding: 1px 4px;
          }
          
          .category-grid {
            grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
            gap: 6px;
          }
          .category-grid .cat-item {
            padding: 8px;
          }
          .category-grid .cat-item .cat-icon-lg {
            font-size: 22px;
          }
          .category-grid .cat-item .cat-name-lg {
            font-size: 11px;
          }
          .category-grid .cat-item .cat-count-lg {
            font-size: 9px;
          }

          .mobile-nav-btn {
            font-size: 8px;
            padding: 2px 6px;
          }
        }

        /* Very small phones */
        @media (max-width: 400px) {
          .pos-header .brand h4 {
            font-size: 10px;
          }
          .pos-header .brand .date-picker-wrapper input[type="date"] {
            width: 60px;
            font-size: 8px;
          }
          .order-type-btn {
            font-size: 7px;
            padding: 1px 5px;
          }
          .pos-center .product-search .MuiOutlinedInput-root {
            height: 26px;
          }
          .pos-center .product-search .MuiOutlinedInput-root input {
            font-size: 10px;
          }
          .pos-center .print-btn {
            height: 24px;
            font-size: 9px;
          }
          .pos-center .print-btn-secondary {
            height: 24px;
            font-size: 9px;
          }
          .pos-left {
            width: 220px;
          }
          .pos-right {
            width: 100%;
            max-width: 100%;
          }
          .pos-right .product-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          .pos-right .product-card .product-image {
            height: 30px;
          }
        }
      `}</style>

      {/* ===== HEADER ===== */}
      <div className="pos-header">
        <div className="brand">
          <FaUtensils size={isMobile ? 18 : 28} />
          <div>
            <h4>Restaurant POS</h4>
            <div className="date-picker-wrapper">
              <FaCalendarAlt className="date-icon" />
              <input 
                type="date" 
                value={manualdate} 
                onChange={handleDateChange}
                max={getToday()}
              />
            </div>
          </div>
        </div>
        <div className="order-type-buttons">
          <button 
            className={`order-type-btn ${orderType === 'dining' ? 'active' : ''}`}
            onClick={() => handleOrderTypeChange('dining')}
          >
            <FaChair /> {isMobile ? 'Dine' : 'Dining'}
          </button>
          <button 
            className={`order-type-btn ${orderType === 'delivery' ? 'active' : ''}`}
            onClick={() => handleOrderTypeChange('delivery')}
          >
            <FaTruck /> {isMobile ? 'Deliv' : 'Delivery'}
          </button>
          <button 
            className={`order-type-btn ${orderType === 'takeaway' ? 'active' : ''}`}
            onClick={() => handleOrderTypeChange('takeaway')}
          >
            <FaRecycle /> {isMobile ? 'Take' : 'Takeaway'}
          </button>
          <button 
            className="order-type-btn"
            onClick={() => setShowOrdersModal(true)}
            style={{ background: 'rgba(255,255,255,0.2)', borderColor: 'rgba(255,255,255,0.5)' }}
          >
            <FaFileInvoice /> {isMobile ? 'Ord' : 'Orders'}
          </button>
        </div>
        <div className="header-right">
          <Badge bg="light" text="dark">
            <FaUser /> {salesman.find(s => s.id === salesmanId)?.name?.split(' ')[0] || 'Sales'}
          </Badge>
          <Badge bg="light" text="dark">
            #{printData.invoiceno || 'NEW'}
          </Badge>
        </div>
      </div>

      {/* ===== MOBILE NAVIGATION BUTTONS ===== */}
      {isMobile && (
        <div className="mobile-nav-buttons">
          <button 
            className={`mobile-nav-btn ${showMobileLeft ? 'active' : ''}`}
            onClick={toggleLeftPanel}
          >
            <FaUser /> Customers
          </button>
          <button 
            className={`mobile-nav-btn ${showMobileCenter ? 'active' : ''}`}
            onClick={toggleCenterPanel}
          >
            <FaPrint /> Cart
          </button>
          <button 
            className={`mobile-nav-btn ${showMobileRight ? 'active' : ''}`}
            onClick={toggleRightPanel}
          >
            <FaUtensils /> Products
          </button>
        </div>
      )}

      {/* ===== MAIN CONTENT ===== */}
      <div className="pos-main">
        {/* Mobile Overlay */}
        {isMobile && (showMobileLeft || showMobileRight) && (
          <div className="mobile-overlay" onClick={() => {
            setShowMobileLeft(false);
            setShowMobileRight(false);
            setShowMobileCenter(true);
          }} />
        )}

        {/* LEFT - CUSTOMERS */}
        <div 
          className={`pos-left ${isMobile && showMobileLeft ? 'mobile-open' : ''}`}
          onClick={(e) => { if (isMobile) e.stopPropagation(); }}
          onTouchStart={(e) => { if (isMobile) e.stopPropagation(); }}
        >
          <div className="customer-header">
            <h6><FaUser /> Customers</h6>
            <Badge bg="secondary" pill>{filteredCustomers.length}</Badge>
          </div>
          
          <div className="customer-search-box">
            <span className="search-icon"><FaSearch size={10} /></span>
            <input
              type="text"
              placeholder="Search customers..."
              value={searchCustomer}
              onChange={handleCustomerSearch}
            />
          </div>

          <div className="customer-list">
            {filteredCustomers.length > 0 ? (
              filteredCustomers.map((customer) => (
                <div
                  key={customer.user_id}
                  className={`customer-item ${selectedCustomer?.user_id === customer.user_id ? 'selected' : ''}`}
                  onClick={() => handleCustomerSelect(customer)}
                >
                  <div className="customer-avatar" style={{ background: isTableCustomer(customer) ? '#d4edda' : '#cce5ff' }}>
                    {isTableCustomer(customer) ? <FaChair size={12} /> : <FaUser size={12} />}
                  </div>
                  <div className="customer-info">
                    <div className="customer-name">{customer.name}</div>
                    <div className="customer-phone">{customer.phone || 'No phone'}</div>
                  </div>
                  <span className="customer-badge">
                    {isTableCustomer(customer) ? 'Dining' : 
                     orderType === 'takeaway' ? 'Takeaway' : 'Delivery'}
                  </span>
                </div>
              ))
            ) : (
              <div className="empty-customers">
                <span className="empty-icon">👥</span>
                <p>No customers found</p>
              </div>
            )}
          </div>

          <button 
            className="add-customer-btn-small"
            onClick={openAddCustomerFromModal}
          >
            <FaUserPlus /> Add New Customer
          </button>
        </div>

        {/* CENTER - BILL/CART */}
        <div className={`pos-center ${isMobile && !showMobileCenter ? 'mobile-hidden' : ''}`}>
          {/* Product Search in Center */}
          <div className="product-search">
            <Autocomplete
              disablePortal
              id="product-search"
              value={selectedOption}
              onChange={(event, newValue) => {
                setSelectedOption(newValue);
                if (newValue) handleSubmit(newValue);
              }}
              autoHighlight
              getOptionLabel={(option) => `${option.name} (${option.alias || ''})`}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              options={results}
              noOptionsText="No products found"
              renderOption={(props, option) => (
                <Box component="li" {...props} key={option.id}>
                  <img 
                    loading="lazy" 
                    src={`${weburl}${option.image}`} 
                    alt="" 
                    width={24} 
                    height={24} 
                    style={{ borderRadius: '3px', objectFit: 'cover' }}
                  />
                  <span style={{ marginLeft: '6px', fontSize: '12px' }}>{option.name}</span>
                  <span style={{ marginLeft: 'auto', color: '#dc3545', fontWeight: 600, fontSize: '11px' }}>
                    Rs{option.unitsaleprice}
                  </span>
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search products..."
                  variant="outlined"
                  size="small"
                  inputRef={autocompleteRef}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' && params.inputProps.value) {
                      const inputText = params.inputProps.value.toLowerCase();
                      const matching = results.filter(opt =>
                        opt.name.toLowerCase().includes(inputText) ||
                        (opt.alias || '').toLowerCase().includes(inputText)
                      );
                      if (matching.length > 0) {
                        setSelectedOption(matching[0]);
                        handleSubmit(matching[0]);
                      }
                    }
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '20px',
                      background: '#f8f9fa',
                    }
                  }}
                />
              )}
            />
          </div>

          <div className="cart-header">
            <h6>🛒 Current Order</h6>
            <div className="header-actions">
              <button 
                className="hold-view-btn"
                onClick={() => setShowHoldModal(true)}
                title="View Held Orders"
              >
                <FaList /> Held
                {holdData.length > 0 && <span className="badge-hold">{holdData.length}</span>}
              </button>
              <Button 
                variant="outline-danger" 
                size="sm" 
                onClick={HandleResetValues}
                disabled={item.length === 0}
                style={{ padding: '2px 6px', fontSize: '10px' }}
              >
                <Clear fontSize="small" />
              </Button>
            </div>
          </div>

          {/* Cart Items */}
          <div className="cart-items">
            {item.length > 0 ? (
              item.map((items, index) => (
                <div className="cart-item slide-in" key={items.id}>
                  <div className="item-details">
                    <div className="item-name">{items.name}</div>
                    <div className="item-controls">
                      <input
                        type="number"
                        min="1"
                        step="1"
                        value={items.qty}
                        onChange={e => {
                          const newQty = parseFloat(e.target.value);
                          if (newQty > 0) {
                            setItem(prev => prev.map((item, i) => 
                              i === index ? { ...item, qty: newQty } : item
                            ));
                          }
                        }}
                        ref={index === item.length - 1 ? inputRef : null}
                        onKeyDown={handleKeyDown}
                      />
                      <span style={{ fontSize: '10px', color: '#888', margin: '0 2px', fontWeight: '500' }}>×</span>
        <input
  type="number"
  min="0"
  step="0"
  defaultValue={items.unitsaleprice}
  key={`price-${items.id}-${index}`}
  onChange={e => {
    const raw = e.target.value;

    // If field is empty → treat as 0 for calculations
    if (raw === '') {
      setItem(prev => prev.map((it, i) => 
        i === index ? { ...it, unitsaleprice: 0 } : it
      ));
      return;
    }

    const newRate = parseFloat(raw);
    if (!isNaN(newRate) && newRate >= 0) {
      setItem(prev => prev.map((it, i) => 
        i === index ? { ...it, unitsaleprice: newRate } : it
      ));
    }
  }}
  onBlur={(e) => {
    // On blur, if empty → set input display to 0 (state already 0)
    if (e.target.value === '') {
      e.target.value = 0;
    }
  }}
  onKeyDown={(e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      // If empty on Enter → show 0 (state already 0 from onChange)
      if (e.target.value === '') {
        e.target.value = 0;
      }
      if (autocompleteRef.current) {
        autocompleteRef.current.focus();
      }
    }
  }}
  style={{
    width: '50px',
    padding: '2px 3px',
    border: '2px solid #28a745',
    borderRadius: '3px',
    fontSize: '10px',
    textAlign: 'center',
    background: '#f0fff4',
    fontWeight: '600',
    color: '#1e7e34',
    transition: 'all 0.3s ease'
  }}
/>
                    </div>
                  </div>
                  <div className="item-total">{(items.qty * items.unitsaleprice).toFixed(2)}</div>
                  <button className="remove-btn" onClick={() => handleRemove(items.id)}>
                    <Clear fontSize="small" />
                  </button>
                </div>
              ))
            ) : (
              <div className="empty-cart">
                <span className="empty-icon">🍽️</span>
                <p>No items in cart</p>
                <small>Search and select products above</small>
              </div>
            )}
          </div>

          {/* Totals */}
          <div className="cart-totals">
            <div className="total-row">
              <span className="total-label">Subtotal</span>
              <span className="total-value">{grandTotal}</span>
            </div>
            <div className="total-row">
              <span className="total-label">Discount</span>
              <input 
                type="number" 
                value={discount || ''} 
                onChange={handleDiscount}
                placeholder="0"
              />
            </div>
            {orderType === 'dining' && (
              <div className="total-row">
                <span className="total-label">S.C (Service)</span>
                <input 
                  type="number" 
                  value={serviceCharge || ''} 
                  onChange={(e) => setServiceCharge(e.target.value === '' ? 0 : parseFloat(e.target.value))}
                  placeholder="0"
                />
              </div>
            )}
            {orderType === 'delivery' && (
              <div className="total-row">
                <span className="total-label">D.C (Delivery)</span>
                <input 
                  type="number" 
                  value={salesTax || ''} 
                  onChange={setSalesTaxInLocalStorage}
                  onKeyDown={handleKeyPress}
                  placeholder="0"
                />
              </div>
            )}
            <div className="total-row grand-total-row">
              <span className="total-label">Grand Total</span>
              <span className="total-value">
                {(
                  parseFloat(grandTotal) + 
                  parseFloat(shipping) + 
                  (orderType === 'delivery' ? parseFloat(salesTax) : 0) + 
                  (orderType === 'dining' ? parseFloat(serviceCharge) : 0) - 
                  parseFloat(discount)
                ).toFixed(2)}
              </span>
            </div>
          </div>

          {/* Payment */}
          <div className="payment-section">
            <div className="payment-row">
              <span>Cash Tendered</span>
              <input 
                type="number" 
                ref={inputRefCash}
                value={entercash || ''} 
                onChange={handleEntercash}
                placeholder="0"
              />
            </div>
            <div className="payment-row" style={{display:'none'}}>
              <span>Balance</span>
              <span className={`balance-amount ${parseFloat(entercash) < parseFloat(grandTotal) ? 'negative' : ''}`}>
                {(
                  parseFloat(salesTaxAmount) + 
                  parseFloat(balance) + 
                  parseFloat(shipping)
                ).toFixed(2)}
              </span>
            </div>
          </div>

          <div className="action-buttons">
            <button 
              className="print-btn" 
              onClick={handlePrintClick} 
              disabled={loading || item.length === 0 || !selectedCustomer}
            >
              {loading ? (
                <><Puff stroke="white" height={20} width={20} speed={0.75} /> Processing...</>
              ) : (
                <><FaPrint /> Print Bill</>
              )}
            </button>
            <button 
              className="print-btn-secondary" 
              onClick={handleHoldOrder}
              disabled={item.length === 0}
            >
              <FaRecycle /> Hold
            </button>
          </div>
          {!selectedCustomer && item.length > 0 && (
            <div style={{ 
              textAlign: 'center', 
              fontSize: '10px', 
              color: '#dc3545',
              marginTop: '2px',
              flexShrink: 0
            }}>
              ⚠️ Select customer from left panel
            </div>
          )}
        </div>

        {/* RIGHT - PRODUCTS */}
        <div 
          className={`pos-right ${isMobile && showMobileRight ? 'mobile-open' : ''}`}
          onClick={(e) => { if (isMobile) e.stopPropagation(); }}
          onTouchStart={(e) => { if (isMobile) e.stopPropagation(); }}
        >
          {isMobile && (
            <div className="mobile-panel-header">
              <h6><FaUtensils /> Products</h6>
              <button 
                className="mobile-panel-close-btn"
                onClick={() => {
                  setShowMobileRight(false);
                  setShowMobileCenter(true);
                }}
              >
                <FaTimes />
              </button>
            </div>
          )}

          {/* Category Trigger Button */}
          <div className="category-trigger" onClick={() => setShowCategoryModal(true)}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <FaUtensils color="#dc3545" size={isMobile ? 12 : 14} />
              <span className="cat-label">Category:</span>
              <span className="cat-selected">
                {selectedCategory ? selectedCategory.name : 'All'}
              </span>
            </div>
            <div className="cat-arrow">
              <FaTimes style={{ fontSize: isMobile ? '10px' : '12px' }} />
            </div>
          </div>

          <div className="product-grid">
            {isproducts ? (
              products.length > 0 ? (
                products.map((product) => {
                  const inCart = isProductInCart(product.id);
                  const cartQty = getProductCartQty(product.id);
                  return (
                    <div 
                      key={product.id} 
                      className={`product-card pulse-hover ${inCart ? 'in-cart' : ''}`}
                      onClick={() => handleSubmit({ id: product.id })}
                    >
                      <img 
                        src={`${weburl}${product.image}`} 
                        alt={product.name} 
                        className="product-image"
                        loading="lazy"
                      />
                      <div className="product-name">{product.name}</div>
                      <div className="product-price">Rs{product.unitsaleprice}</div>
                      <div className="product-unit">{product.unit}</div>
                      {inCart && <span className="cart-qty-badge">{cartQty} in cart</span>}
                      <button className="quick-add-btn">+ Add</button>
                    </div>
                  );
                })
              ) : (
                <div className="empty-customers" style={{ gridColumn: '1 / -1' }}>
                  <span className="empty-icon">📦</span>
                  <p>No products found</p>
                </div>
              )
            ) : (
              <div className="loading-products">
                <Puff stroke="#dc3545" height={30} width={30} speed={0.75} />
                <p style={{ fontSize: '11px' }}>Loading products...</p>
              </div>
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pagination-controls">
              <button
                className="page-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(p => p - 1)}
              >
                Prev
              </button>
              <span className="page-info">
                {currentPage} / {totalPages}
              </span>
              <button
                className="page-btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(p => p + 1)}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>

      {/* ===== CATEGORY SELECTION MODAL ===== */}
      <Modal
        show={showCategoryModal}
        onHide={() => setShowCategoryModal(false)}
        centered
        size="lg"
        className="category-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaUtensils /> Select Category
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="category-grid">
            <div 
              className="cat-item"
              onClick={loadAllProducts}
              style={{ border: !selectedCategory ? '2px solid #dc3545' : '2px solid transparent' }}
            >
              <div className="cat-icon-lg">📋</div>
              <div className="cat-name-lg">All Products</div>
              <div className="cat-count-lg">{products.length} items</div>
            </div>
            {category.map((cat) => (
              <div 
                key={cat.id}
                className="cat-item"
                onClick={() => handleFetchProductCategoryWise(cat.id)}
                style={{ border: selectedCategory?.id === cat.id ? '2px solid #dc3545' : '2px solid transparent' }}
              >
                <div className="cat-icon-lg">📁</div>
                <div className="cat-name-lg">{cat.name}</div>
                <div className="cat-count-lg">{cat.product_count || 0} items</div>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCategoryModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ===== HOLD ORDERS MODAL ===== */}
      <Modal 
        show={showHoldModal} 
        onHide={() => {
          setShowHoldModal(false);
          setShowHoldDetails(false);
        }}
        centered
        size="xl"
        className="hold-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaRecycle /> Held Orders ({holdData.length})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {holdData.length > 0 ? (
            <div className="hold-table-wrapper">
              <table className="hold-table">
                <thead>
                  <tr>
                    <th className="col-customer">Customer</th>
                    <th className="col-type">Order Type</th>
                    <th className="col-items">Items</th>
                    <th className="col-total">Total</th>
                    <th className="col-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {holdData.map((hold, index) => {
                    const total = hold.items?.reduce((sum, item) => sum + (item.unitsaleprice * item.qty), 0) || 0;
                    const customerName = hold.customer?.name || 'Unknown Customer';
                    const orderTypeLabel = hold.orderType || 'dining';

                    return (
                      <tr className="hold-row fade-in-up" key={index}>
                        <td className="col-customer">
                          <div className="hold-customer-cell">
                            <FaUser className="row-icon" />
                            <span>{customerName}</span>
                          </div>
                        </td>
                        <td className="col-type">
                          <span className={`order-type-badge ${orderTypeLabel}`}>
                            {orderTypeLabel === 'dining' ? <FaChair /> : 
                            orderTypeLabel === 'delivery' ? <FaTruck /> : <FaRecycle />}
                            {' '}{orderTypeLabel.charAt(0).toUpperCase() + orderTypeLabel.slice(1)}
                          </span>
                        </td>
                        <td className="col-items">
                          <div className="hold-items-preview">
                            {hold.items?.slice(0, 3).map((item, idx) => (
                              <span className="item-tag" key={idx}>
                                {item.name} × <span>{item.qty}</span>
                              </span>
                            ))}
                            {hold.items?.length > 3 && (
                              <span className="item-tag more-tag">+{hold.items.length - 3} more</span>
                            )}
                          </div>
                        </td>
                        <td className="col-total">
                          <span className="hold-total-value">Rs {total.toFixed(2)}</span>
                        </td>
                        <td className="col-actions">
                          <div className="hold-actions">
                            <button className="view-btn" title="View" onClick={() => handleViewHoldDetails(hold, index)}>
                              <FaEye />
                            </button>
                            <button 
                              className="print-btn-hold" 
                              title="Print Invoice" 
                              onClick={() => handlePrintHoldInvoice(hold, index)}
                            >
                              <FaPrint />
                            </button>
                            <button className="restore-btn" title="Restore" onClick={() => handleHoldBack(index)}>
                              <FaUndo />
                            </button>
                            <button className="delete-btn" title="Delete" onClick={(e) => handleDeleteOnHold(e, index)}>
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-holds-modal">
              <span className="empty-icon">📋</span>
              <h5>No Orders on Hold</h5>
              <p className="text-muted">You can hold orders from the main POS screen</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowHoldModal(false);
            setShowHoldDetails(false);
          }}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ===== HOLD ORDER DETAILS MODAL ===== */}
      <Modal
        show={showHoldDetails}
        onHide={() => setShowHoldDetails(false)}
        centered
        size="md"
        className="hold-detail-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaEye /> Order Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedHoldOrder && (
            <>
              <div style={{ marginBottom: '12px' }}>
                <strong>Customer:</strong> {selectedHoldOrder.customer?.name || 'Unknown Customer'}
                <br />
                <strong>Order Type:</strong> {selectedHoldOrder.orderType || 'dining'}
                <br />
                <strong>Items:</strong> {selectedHoldOrder.items?.length || 0}
              </div>
              <div style={{ borderTop: '1px solid #eee', paddingTop: '10px' }}>
                {selectedHoldOrder.items?.map((item, idx) => (
                  <div className="hold-detail-item" key={idx}>
                    <span className="item-name">{item.name} × {item.qty}</span>
                    <span className="item-price">Rs {(item.unitsaleprice * item.qty).toFixed(2)}</span>
                  </div>
                ))}
              </div>
              <div className="hold-detail-total">
                Grand Total: <span>
                  Rs {selectedHoldOrder.items?.reduce((sum, item) => sum + (item.unitsaleprice * item.qty), 0).toFixed(2)}
                </span>
              </div>
              <div style={{ marginTop: '12px', display: 'flex', gap: '6px', justifyContent: 'flex-end' }}>
                <Button 
                  variant="info" 
                  size="sm"
                  onClick={() => {
                    handlePrintHoldInvoice(selectedHoldOrder, selectedHoldOrder.index);
                  }}
                >
                  <FaPrint /> Print Invoice
                </Button>
                <Button 
                  variant="success" 
                  size="sm"
                  onClick={() => {
                    handleHoldBack(selectedHoldOrder.index);
                    setShowHoldDetails(false);
                  }}
                >
                  <FaUndo /> Restore Order
                </Button>
                <Button 
                  variant="danger" 
                  size="sm"
                  onClick={() => {
                    handleDeleteOnHold({ preventDefault: () => {}, stopPropagation: () => {} }, selectedHoldOrder.index);
                    setShowHoldDetails(false);
                  }}
                >
                  <FaTrash /> Delete Order
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      {/* ===== ORDER MANAGEMENT MODAL ===== */}
      <OrderManagement 
        show={showOrdersModal}
        onHide={() => setShowOrdersModal(false)}
        onOrderComplete={handleOrderComplete}
      />

      {/* Hidden components */}
      <div style={{ display: 'none' }}>
        {isPrint && <PrintSaleInvoice data={printData} />}
        {isAddUser && (
          <AddUserModel 
            show={isAddUser} 
            onChildSubmit={handleAddNewUser} 
            onChildClose={handleModelClose} 
          />
        )}
      </div>
    </div>
  );
}

export default FreshSaleEntry;